import React, { useEffect } from "react";
import "./FoodProductsScienceModal.css";
import tile6 from "../assets/tile6exploremore.png";

const FoodProductsScienceModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fps-overlay" onClick={onClose}>
      <div className="fps-container" onClick={(e) => e.stopPropagation()}>
        <button className="fps-close" onClick={onClose}>&times;</button>

        <div className="fps-content" style={{ display: 'flex', height: '92vh' }}>
          {/* Right — Image */}
          <div
            className="fps-image"
            style={{
              flex: '0 0 42%',
              minWidth: '42%',
              backgroundImage: `url(${tile6})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
              order: 2,
            }}
          />

          {/* Left — Text */}
          <div className="fps-text" style={{ flex: '1 1 0%', minWidth: 0, order: 1, overflowY: 'auto', padding: '3rem' }}>
            <h1>SCIENCE BEHIND OUR FOOD PRODUCTS</h1>

            <p>
              Each formulation is designed to support biological functions through carefully
              selected natural ingredients, rather than focusing only on taste or convenience.
            </p>

            <p>
              We research on the nutrient composition and phytochemical profiles of foods to
              understand how different ingredients contribute to metabolic processes, cellular
              protection, and physiological balance.
            </p>

            <p>This allows us to combine foods in ways that support:</p>

            <ul className="fps-bullets">
              <li>Digestion and nutrient absorption.</li>
              <li>Energy metabolism and metabolic signalling.</li>
              <li>Immune function.</li>
              <li>Gut barrier integrity and microbiome balance.</li>
            </ul>

            <p>
              Restoring these foundational processes supports the body's ability to regulate
              itself and sustain physiological resilience. RASAI NUTRIE food products are
              designed to integrate into day to day life, providing consistent nutritional
              support over time.
            </p>

            <blockquote className="fps-quote">
              "Understanding the science of food allows nutrition to work in harmony with
              human biology."
            </blockquote>

            <button className="fps-back-btn" onClick={onClose}>Back to Home</button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FoodProductsScienceModal;
